module.exports = __webpack_public_path__ + "static/media/ratchetCard.d27ccad6.jpg";